export default __webpack_public_path__ + "assets/img/image1.png";